import { useEffect, useRef } from 'react';

export const useScrollToTop = (
  containerRef: React.RefObject<HTMLElement>,
  messagesLength: number,
  isStreaming: boolean
) => {
  const prevLength = useRef(0);
  const lastUserMsgRef = useRef<HTMLDivElement>(null) as React.RefObject<HTMLDivElement>;
  const lastAiMsgRef = useRef<HTMLDivElement>(null) as React.RefObject<HTMLDivElement>;

  useEffect(() => {
    const container = containerRef.current;
    const lastUserMsg = lastUserMsgRef.current;
    if (!container || !lastUserMsg || !isStreaming || messagesLength <= prevLength.current) return;

    container.scroll({
      top: lastUserMsg.offsetTop - container.offsetTop,
      behavior: 'smooth',
    });

    prevLength.current = messagesLength;
  }, [messagesLength, isStreaming]);

  useEffect(() => {
    if (isStreaming || messagesLength === 0) return;

    const container = containerRef.current;
    const lastAiMsg = lastAiMsgRef.current;
    if (!container || !lastAiMsg) return;

    const containerRect = container.getBoundingClientRect();
    const aiRect = lastAiMsg.getBoundingClientRect();

    if (aiRect.bottom >= containerRect.bottom) {
      lastAiMsg.style.setProperty('--last-ai-message-margin', '0px');
    } else {
      const diff = containerRect.bottom - aiRect.bottom;
      lastAiMsg.style.setProperty('--last-ai-message-margin', `${diff}px`);
    }

    prevLength.current = messagesLength;
  }, [isStreaming]);

  return { lastUserMsgRef, lastAiMsgRef };
};
